module.exports = __webpack_public_path__ + "static/media/donut.c9cfa41d.jpg";